export enum OriginationChannelEnum {
  DirectToCustomer = "DirectToCustomer",
  MerchantConsole = "MerchantConsole",
}
